import f1 from '../images/netsurf-fixy/f1.png';
import f2 from '../images/netsurf-fixy/f2.png';
import f3 from '../images/netsurf-fixy/f3.png';
import f4 from '../images/netsurf-fixy/f4.png';
import f5 from '../images/netsurf-fixy/f5.png';
import f6 from '../images/netsurf-fixy/f6.png';

export default {
	features: [
		{ image: f1 },
		{ image: f2 },
		{ image: f3 },
		{ image: f4 },
		{ image: f5 },
		{ image: f6 }
	]
};
